import type { RoundState } from '@magic/slot';

/**
 * Alignment check board — a zero-win round served on first load.
 *
 * Each reel ships `rows + 2` cells: index 0 is the hidden buffer above the
 * visible window, 1…3 are the visible rows, and 4 is the hidden buffer below
 * (see `ReelController.normalizeBoard`). So every reel here reads
 * `[H1, L1, L2, L3, H5]` and the game must open on three clean rows:
 *
 *     row 1  L1 L1 L1 L1 L1
 *     row 2  L2 L2 L2 L2 L2
 *     row 3  L3 L3 L3 L3 L3
 *
 * The H1/H5 buffers are deliberately unlike the L symbols: if one of them shows
 * up on screen, the board is off by a row.
 */
const reel = [{ name: 'H1' }, { name: 'L1' }, { name: 'L2' }, { name: 'L3' }, { name: 'H5' }];

export const baseRound: RoundState[] = [
    {
        index: 0,
        type: 'reveal',
        board: [reel, reel, reel, reel, reel],
        paddingPositions: [111, 160, 13, 73, 99],
        gameType: 'basegame',
        // no scatters on this board, so nothing to tease
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 1,
        type: 'setTotalWin',
        amount: 0,
    },
    {
        index: 2,
        type: 'finalWin',
        amount: 0,
    },
];
